import { Tab } from "@mui/material";
import { MprcContainer } from "components";
import { MprcChipTabs } from "components/MprcChipTabs";
import { TrainingPanelDrillOption } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

interface IProps {
    selectedOption: TrainingPanelDrillOption;
    onChange: (value: TrainingPanelDrillOption) => void;
}

export const ChooseTrainingOrTopic = ({ selectedOption, onChange }: IProps) => {
    const { t } = useTranslation("dashboard");

    return <MprcContainer>
        <MprcChipTabs size="medium" value={selectedOption} onChange={(e, value) => onChange(value)}>
            <Tab label={t("TrainingPanel.Tabs.Trainings")} value={TrainingPanelDrillOption.Trainings} sx={{ minWidth: 180 }} />
            <Tab label={t("TrainingPanel.Tabs.Topics")} value={TrainingPanelDrillOption.Topics} sx={{ minWidth: 180 }} />
        </MprcChipTabs>
    </MprcContainer>;
};
